var anchor = require('../navigation/anchor');
var observe = require('../../lib/util/observe');
var template = require('./deck-header.tpl').default;

module.exports = DomClass(template, function DeckHeader() {
	var _t = this;

	this.endpoint = this.endpoint || 'decks';

	var update_href = function() {
		_t.anchor.href = '?' + _t.endpoint + '/' + _t.$id;
		_t.anchor.body = _t.name;
	};

	update_href();
	observe(this, ['endpoint', '$id'], update_href);

	this.toJSON = () => ({
		$id: this.$id,
		name: this.name
	});

});
